import { defaultTheme } from "../../shared/constants";
import styled, { css } from "styled-components";

export const StyledRow = styled.div<{ pt?: number }>`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;

  ${({ pt }) =>
    pt &&
    css`
      padding-top: ${pt}px;
    `}
`;

export const StyledLabel = styled.label`
  font-family: ${() => defaultTheme.FONT.FAMILY.BODY};
  font-size: 1rem;
  line-height: 1.1;
  display: grid;
  grid-template-columns: 1rem auto;
  gap: 0.5rem;
  place-items: center;
  cursor: pointer;
`;

export const StyledInput = styled.input<{ checked: boolean }>`
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  font: inherit;
  color: ${() => defaultTheme.COLORS.GRAY_BLACK};
  width: 1rem;
  height: 1rem;
  border: 0.1rem solid ${() => defaultTheme.COLORS.GRAY};
  border-radius: 50%;
  transform: translateY(-0.075rem);
  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ checked }) =>
    checked &&
    css`
      border: 0.1rem solid ${() => defaultTheme.COLORS.ACTION_BLUE};
      &::before {
        content: "";
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        transform: scale(0);
        box-shadow: inset 1rem 1rem ${() => defaultTheme.COLORS.ACTION_BLUE};
      }

      &:checked::before {
        transform: scale(1);
      }
    `}
`;

export const StyledContent = styled.div`
  display: flex;
  align-items: center;
`;
